import { useState, useEffect, SyntheticEvent,  } from "react";
import { Image, Form, FormGroup, FormField, Dropdown, Button, Icon, DropdownProps } from "semantic-ui-react";

// Components
import ModInfo from "react-lib/appcon/common/ModInfo";

type ModPrintMedicalReportProps = {
  open: boolean;
  onClose: () => void;

  // callback
  onEvent?: any;

  // data
  packageData: any; // -- pkg จาก item
  encounter: number;
  masterOptions: any[];

  // config
  isDisabledSentMobile?: boolean;
};

const ModPrintMedicalReport = (props: ModPrintMedicalReportProps) => {
  const [language, setLanguage] = useState<"th" | "en">("th");

  useEffect(() => {
    if (props.open) {
      setLanguage("th");
    }
  }, [props.open]);
  
  const handleChangeDropdown = (e: SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    const { name, value } = data;    
    setLanguage(value as "th" | "en");
  };

  const handlePrintMedicalReport = () => {
    props.onEvent({
      message: "PrintMedicalReportPatientQueue",
      params: {
        encounter: props.encounter,
        language,
        checkupReport: props.packageData?.checkup_report_id, // todo --- รอชื่อ field จากหลังบ้าน
        masterOptions: props.masterOptions,
      },
    });
  };

  return (
    <ModInfo
      open={props.open}
      onClose={props.onClose}
      size="tiny"
      titleColor="blue"
      titleName={
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Image
            src={`/static/images/order_images/medical_report_pending.png`}
            style={{ width: 30, height: 30, objectFit: "contain", color: "white" }}
          />
          Medical Report
        </div>
      }
      children={
        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Form style={{ width: "100%" }}>
            <FormGroup inline style={{ width: "100%" }}>
              <FormField width={props.isDisabledSentMobile ? 8 : 4}>
                <div style={{ width: "100%" }}>
                  <Dropdown
                    name="language"
                    fluid
                    selection
                    options={[
                      { key: "th", value: "th", text: "TH" },
                      { key: "en", value: "en", text: "EN" }
                    ]}
                    onChange={handleChangeDropdown}
                    value={language}
                  />
                </div>
              </FormField>
              <FormField width={props.isDisabledSentMobile ? 8 : 6}>
                <div style={{ width: "100%", paddingRight: props.isDisabledSentMobile ? 0 : "undefined" }}>
                  <Button
                    color="yellow"
                    fluid
                    // loading={isLoadingPrintCheckupReport}
                    onClick={handlePrintMedicalReport}
                  >
                    <Icon name="print" />
                    Medical Report
                  </Button>
                </div>
              </FormField>
              {!props.isDisabledSentMobile && (
                <FormField width={6} style={{ paddingRight: 0 }}>
                  <div style={{ width: "100%" }}>
                    <Button
                      style={{ display: props.isDisabledSentMobile ? "none" : null }}
                      color="purple"
                      fluid
                      onClick={() => console.log("Send to Mobile is not available yet")}
                    >
                      <Icon name="mobile alternate" />
                      Send to Mobile
                    </Button>
                  </div>
                </FormField>
              )}
            </FormGroup>
          </Form>
        </div>
      }
      btnText={"Close"}
      buttonColor={"red"}
      onApprove={props.onClose}
    />
  );
};

export default ModPrintMedicalReport;